/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum TransportRequestTypes {
    ToWebServer = 'ToWebServer',
    ToRestServer = 'ToRestServer',
    ToDownloadFile = 'ToDownloadFile',
    ToStreamUploadFile = 'ToStreamUploadFile',
    ToStreamUploadFileRest = 'ToStreamUploadFileRest',
    ToUploadFormData = 'ToUploadFormData',
}
